var drawer = function () {

    /**
     * Element.closest() polyfill
     * https://developer.mozilla.org/en-US/docs/Web/API/Element/closest#Polyfill
     */
    if (!Element.prototype.closest) {
        if (!Element.prototype.matches) {
            Element.prototype.matches = Element.prototype.msMatchesSelector || Element.prototype.webkitMatchesSelector;
        }
        Element.prototype.closest = function (s) {
            var el = this;
            var ancestor = this;
            if (!document.documentElement.contains(el)) return null;
            do {
                if (ancestor.matches(s)) return ancestor;
                ancestor = ancestor.parentElement;
            } while (ancestor !== null);
            return null;
        };
    }


    //
    // Settings
    //
    var settings = {
        speedOpen: 10,
        speedClose: 350,
        activeClass: 'is-active',
        visibleClass: 'is-visible',
        selectorTarget: '[data-drawer-target]',
        selectorTrigger: '[data-drawer-trigger]',
        selectorClose: '[data-drawer-close]',

    };


    //
    // Methods
    //

    // Toggle accessibility
    var toggleccessibility = function (event) {
        if (event.getAttribute('aria-expanded') === 'true') {
            event.setAttribute('aria-expanded', false);
        } else {
            event.setAttribute('aria-expanded', true);
        }
    };

    // Open Drawer

    var if_opened = false;
    var openDrawer = function (trigger) {
        if_opened = false;
        // Find target
        var target = document.getElementById(trigger.getAttribute('aria-controls'));

        // $(".hamburger").removeClass("active");
        // $(".hamburger").css("display", "none");

        // Make it active
        target.classList.add(settings.activeClass);

        // Toggle accessibility
        toggleccessibility(trigger);

        // Make it visible
        setTimeout(function () {
            target.classList.add(settings.visibleClass);
        }, settings.speedOpen);

        $('#shopify-section-header').css('padding-top', '0');
        $('[data-slide-down-current]').slideUp(300);
        $('[data-slide-down-current]').removeClass('active');
        $('body').css('overflow', 'hidden')
    };

    // Close Drawer
    var closeDrawer = function (event) {
        if_opened = false;
        // Find target
        var closestParent = event.closest(settings.selectorTarget),
            childrenTrigger = document.querySelector('[aria-controls="' + closestParent.id + '"');

        // Make it not visible
        closestParent.classList.remove(settings.visibleClass);

        // Toggle accessibility
        toggleccessibility(childrenTrigger);

        // Make it not active
        setTimeout(function () {
            closestParent.classList.remove(settings.activeClass);
            if_opened = false;
        }, settings.speedClose);

        $('body').css('overflow', 'auto');
    };

    // Click Handler
    var clickHandler = function (event) {

        // Find elements
        var toggle = event.target;

        if ($(toggle).hasClass('add-cart')){
            var open = toggle;
            var close = $(settings.selectorClose);
        } else {
            var open = toggle.closest(settings.selectorTrigger);
            var close = toggle.closest(settings.selectorClose);
        }

        // Open drawer when the open button is clicked
        if (open && !if_opened) {
            openDrawer(open);
            if_opened = true;
        } else {
            // console.log('closd1')
            // closeDrawer(close);
            if_opened = false;
        }

        // Close drawer when the close button (or overlay area) is clicked
        if (close) {
            closeDrawer(close);
        }

        // Prevent default link behavior
        if (open || close) {
            event.preventDefault();
        }

    };

    // Keydown Handler, handle Escape button
    var keydownHandler = function (event) {

        if (event.key === 'Escape' || event.keyCode === 27) {

            // Find all possible drawers
            var drawers = document.querySelectorAll(settings.selectorTarget),
                i;

            // Find active drawers and close them when escape is clicked
            for (i = 0; i < drawers.length; ++i) {
                if (drawers[i].classList.contains(settings.activeClass)) {
                    closeDrawer(drawers[i]);
                }
            }

        }

    };


    //
    // Inits & Event Listeners
    //
    document.addEventListener('click', clickHandler, false);
    document.addEventListener('keydown', keydownHandler, false);


};

drawer();

const drawerRemoveItem = async (line) => {
    let formData1 = {
        'quantity': 0,
        'line': line
    };

    const product = await fetch('/cart/change.js', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(formData1)
    }).then(response => {
        return response.json();
    });

    product;
}

const drawerChangeItemById = async (ID, QNT) => {
    let formData1 = {
        'id': ID,
        'quantity': QNT
    };

    const product = await fetch('/cart/change.js', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(formData1)
    }).then(response => {
        return response.json();
    });

    product;
}

const drawerChangeItemAndFrame = async (ID1, QNT1, ID2, QNT2) => {
    let formData1 = {
        'id': ID1,
        'quantity': QNT1
    };
    let formData2 = {
        'id': ID2,
        'quantity': QNT2
    };

    const frame = await fetch('/cart/change.js', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(formData1)
    }).then(response => {
        return response.json();
    }).then(function (){
      drawerUpdate();
    });
    const product = await fetch('/cart/change.js', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(formData2)
    }).then(response => {
        return response.json();
    }).then(function (){
      drawerUpdate();
    });

    frame;
    product;
}
let first_frame_product = $("#drawer-name").data("frame-one");
let second_frame_product = $("#drawer-name").data("frame-two");
var drawerUpdate = function (curr) {
    $.getJSON('/cart.js', function (cart) {
        var currCount = $(".drawer-cart-counter").text().split(/[\s)(]+/)
        var cartCount = currCount[1];
        curr = cart.item_count;

        if (cartCount != curr) {
            var result = cart.item_count;
            $(".drawer-cart-counter").text("(" + result + ")");
            $('.header-cart__count.header-cart-qty').text("(" + result + ")");

            $(".drawer__content-product-items").html("");

            if (cart.items.length == 0) {
                $(".drawer__content-product-items").append("<p class='cart-empty-message'>Your cart is empty</p>");
            } else {
                $(".cart-empty-message").text(" ");
            }
            for (let i = 0; i < cart.items.length; i++) {
                let productSku1 = cart.items[i].sku;
                let productSize1 = '';
                let productTitle1 = cart.items[i].product_title;

                let variants = "";
                for (let j = 0; j < cart.items[i].options_with_values.length; j++) {
                    variants = variants + '<li>' + cart.items[i].options_with_values[j].name + ' : ' + cart.items[i].options_with_values[j].value + '</li>'
                    var line_item = i + 1;

                    if (cart.items[i].options_with_values[j].name.toLowerCase() == 'size') {
                        productSize1 = cart.items[i].options_with_values[j].value;
                    }
                }


                let frameButton = "";
                let frameKey = "";

                if (cart.items[i].product_id != first_frame_product && cart.items[i].product_id != second_frame_product) {
                    let framedProduct = false;
                    let productSku2 = '';
                    let productSize2 = '';
                    let productTitle2 = '';

                    let GiftCard = false;
                    
                    GiftCard = cart.items[i].gift_card;

                    for (let fr = 0; fr < cart.items.length; fr++) {
                        if (cart.items[fr].product_id == first_frame_product || cart.items[fr].product_id == second_frame_product) {
                            let propData = cart.items[fr].properties;
                            productTitle2 = propData['Product'];
                            productSku2 = propData['_Product SKU'];
                            for (let frj = 0; frj < cart.items[fr].options_with_values.length; frj++) {
                                if (cart.items[fr].options_with_values[frj].name.toLowerCase() == 'size') {
                                    productSize2 = cart.items[fr].options_with_values[frj].value;
                                }
                            }

                            if ((productSku1 == productSku2) && (productSize1 == productSize2) && (productTitle1 == productTitle2)) {
                                framedProduct = true;
                                frameKey = cart.items[fr].key;
                            }
                            
                        }
                    }

                    if (!framedProduct) {
                        if (!GiftCard) {
                          frameButton = frameButton + '<li><a href=' + cart.items[i].url + '#only-frame>Want to add a frame? Click here.</a></li>'
                        }
                    }
                }

                let prop = "";
                let propData = cart.items[i].properties;
                for (let x in propData) {
                    if (x.charAt(0) !== '_' ) {
                      if(x == "Frame" || x == "Framed") {
                        prop = prop + '<li>' + propData[x] + '</li>'
                      } else {
                        prop = prop + '<li>' + x + ' : ' + propData[x] + '</li>'
                      }

                    }
                };

                let prodLink = cart.items[i].url;
                let dataSKU = cart.items[i].sku;
                let dataTitle = cart.items[i].product_title;
                dataTitle = dataTitle.replaceAll("'", '');

                if (cart.items[i].product_id == first_frame_product || cart.items[i].product_id == second_frame_product ) {
                    dataTitle = propData['Product'];
                    dataSKU = propData['_Product SKU'];
                    prodLink = '#';
                }

                let qtySelector = '';
                if (cart.items[i].product_id == first_frame_product || cart.items[i].product_id == second_frame_product ) {
                    if (cart.items[i].quantity > 1) {
                        qtySelector = '                <div class="qty-ajax-cart-wrap-frame" data-title="' + dataTitle + '" data-sku="' + dataSKU + '" data-qnt="' + cart.items[i].quantity + '" data-product="frame" data-key="' + cart.items[i].key + '">Quantity: ' + cart.items[i].quantity + '</div>\n';
                    } else {
                        qtySelector = '';
                    }
                } else {
                    qtySelector = '                <div class="change-qty-ajax-cart-wrap"> \n' +
                        '                <div class="change-qty-ajax-cart" id="remove-item-' + line_item + '">' +
                        '                <div class="minus-button qty-ajax-cart" id="minus-btn" data-action="minus" data-key="' + cart.items[i].key + '" line-item="' + line_item + '" quantity = "' + cart.items[i].quantity + '"><button class="quantity__button quantity__button-custom no-js-hidden" name="minus" type="button">\n' +
                        '                        <svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false" role="presentation" class="icon icon-minus" fill="none" viewBox="0 0 10 2">\n' +
                        '  <path fill-rule="evenodd" clip-rule="evenodd" d="M.5 1C.5.7.7.5 1 .5h8a.5.5 0 110 1H1A.5.5 0 01.5 1z" fill="currentColor">\n' +
                        '</path></svg>\n' +
                        '\n' +
                        '                      </button>' +
                        '</div>' +
                        '                <input class="qty-change-ajax-cart" readonly data-framekey="' + frameKey + '" data-title="' + dataTitle + '" data-sku="' + dataSKU + '" id="input-line-item-' + line_item + '" type="number" min="0" value="' + cart.items[i].quantity + '">' +
                        '                <div class="plus-button qty-ajax-cart" id="plus-btn" data-action="plus" data-key="' + cart.items[i].key + '" line-item="' + line_item + '" quantity = "' + cart.items[i].quantity + '"> <button class="quantity__button quantity__button-custom no-js-hidden" name="plus" type="button">\n' +
                        '                        <svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false" role="presentation" class="icon icon-plus" fill="none" viewBox="0 0 10 10">\n' +
                        '  <path fill-rule="evenodd" clip-rule="evenodd" d="M1 4.51a.5.5 0 000 1h3.5l.01 3.5a.5.5 0 001-.01V5.5l3.5-.01a.5.5 0 00-.01-1H5.5L5.49.99a.5.5 0 00-1 .01v3.5l-3.5.01H1z" fill="currentColor">\n' +
                        '</path></svg>\n' +
                        '\n' +
                        '                      </button></div>' +
                        '                 </div>\n' +
                        '              </div>\n';
                }

                $(".drawer__content-product-items").append('' +

                    '<div class="drawer__content-product-item">\n' +
                    '            <div class="drawer__content-product-item-wrap">\n' +
                    '<a href="' + prodLink + '">' +
                    '              <img class="drawer__content-product-item-image" src="' + cart.items[i].featured_image.url + '">\n' +
                    '              </a>\n' +
                    '              <div class="drawer__content-product-item-info">\n' +
                    '                <div class="drawer__content-product-item-title-price">\n' +
                    '                  <div class="drawer__content-product-item-title">\n' +
                    '                     \n' + cart.items[i].product_title +
                    '                  </div>\n' +
                    '                  <div class="drawer__content-product-item-price">\n' +
                    '                    \n' + Shopify.formatMoney(cart.items[i].final_line_price) +
                    '                  </div>\n' +
                    '                </div>\n' +
                    '                <ul class="drawer__content-product-item-prop">\n' +
                    '                 ' + variants +
                    '                 ' + prop +
                    '                 ' + frameButton +
                    '                </ul>\n' +
                    '                <div class="change-remove-items-ajax-cart">\n' +
                    '                ' + qtySelector +
                    '                <div class="remove-item-ajax-cart-wrap"> \n' +
                    '                  <span class="remove-item-ajax-cart" data-id="' + cart.items[i].key + '" data-title="' + dataTitle.replaceAll("'", "") + '" data-sku="' + dataSKU + '" id="remove-item-' + line_item + '">' +
                    '                     <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" aria-hidden="true" focusable="false" role="presentation" class="icon icon-remove">\n' +
                    '                       <path d="M14 3h-3.53a3.07 3.07 0 00-.6-1.65C9.44.82 8.8.5 8 .5s-1.44.32-1.87.85A3.06 3.06 0 005.53 3H2a.5.5 0 000 1h1.25v10c0 .28.22.5.5.5h8.5a.5.5 0 00.5-.5V4H14a.5.5 0 000-1zM6.91 1.98c.23-.29.58-.48 1.09-.48s.85.19 1.09.48c.2.24.3.6.36 1.02h-2.9c.05-.42.17-.78.36-1.02zm4.84 11.52h-7.5V4h7.5v9.5z" fill="currentColor"/>\n' +
                    '                       <path d="M6.55 5.25a.5.5 0 00-.5.5v6a.5.5 0 001 0v-6a.5.5 0 00-.5-.5zM9.45 5.25a.5.5 0 00-.5.5v6a.5.5 0 001 0v-6a.5.5 0 00-.5-.5z" fill="currentColor"/>\n' +
                    '                    </svg>\n  ' +
                    '                  </span>\n' +
                    '                 <div class="loading-overlay loading-overlay--ajax hidden"> \n' +
                    '                   <div class="loading-overlay__spinner"> \n' +
                    '                      <svg aria-hidden="true" focusable="false" role="presentation" class="spinner" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg"> \n' +
                    '                        <circle class="path" fill="none" stroke-width="6" cx="33" cy="33" r="30"></circle> \n' +
                    '                      </svg> \n' +
                    '                   </div> \n' +
                    '                 </div> \n' +
                    '               </div>\n' +
                    '              </div>\n' +
                    '                 </div>\n' +
                    '          </div></a>');
            }
            $(".drawer__content-total-amount").text(Shopify.formatMoney(cart.total_price));
            curr = cartCount;
        }
    });
}

$(document).on("click", ".remove-item-ajax-cart", function () {
    $(this).parent(".remove-item-ajax-cart-wrap").find(".loading-overlay--ajax").removeClass('hidden');
    var line1 = this.id.replace("remove-item-", "");
    let id1 = $(this).data("id");
    let sku = $(this).data("sku");
    let title = $(this).data("title");
  let replaced = title.replaceAll("'", '');
    if (id1 != first_frame_product && id1 != second_frame_product) {
         console.log("replaced =" + replaced);
      let elem = $("span[data-sku='" + sku + "'][data-title='" + replaced + "'][data-id!='" + id1 + "']");
        elem.parent(".remove-item-ajax-cart-wrap").find(".loading-overlay--ajax").removeClass('hidden');
        if (replaced.indexOf("Gift Card") >= 0) {
             drawerChangeItemById(id1, 0);
        } else {
            if (elem.length != 0) {
                var line2 = elem.prop('id').replace("remove-item-", "");
                let id2 = elem.data("id");
                drawerChangeItemAndFrame(id1, 0, id2, 0);
            } else {
                drawerChangeItemById(id1, 0);
            }
        }
    } else {
        drawerChangeItemById(id1, 0);
    }
    setTimeout(function (){
      drawerUpdate();
    }, 1000);
});

$(document).on("click", ".qty-ajax-cart", function () {
    $(this).closest(".change-remove-items-ajax-cart").find(".remove-item-ajax-cart-wrap").find(".loading-overlay--ajax").removeClass('hidden');

    let action = $(this).data('action');
    let line = $(this).attr('line-item');
    let key = $(this).data('key');
    let qty = $("#input-line-item-" + line).val();
    let title = $("#input-line-item-" + line).data('title');
    let sku = $("#input-line-item-" + line).data('sku');
    let replaced = title.replaceAll("'", '');
    let frame = $("div[data-sku='" + sku + "'][data-title='" + replaced + "'][data-product='frame']");
    let frameQnt = frame.data('qnt');
    let frameKey = frame.data('key');

    if (action == 'plus') {
        qty = Number(qty) + 1;
        $(this).attr('quantity', qty);
    } else if (action == 'minus') {
        qty -= 1;
        $(this).attr('quantity', qty);
    }

    $("input#input-line-item-" + line).val(qty);

    if (qty == 0) {
        let frame_key = $("#input-line-item-" + line).data('framekey');
        drawerChangeItemAndFrame(key, 0, frame_key, 0);
    } else if (frameQnt > qty) {
        drawerChangeItemAndFrame(key, qty, frameKey, qty);
    } else {
        drawerChangeItemById(key, qty);
    }
    setTimeout(function (){
      drawerUpdate();
    }, 1000)
});

$(document).mouseup(function (e) {
    var container = $(".drawer__wrapper");
    if (!container.is(e.target) && container.has(e.target).length === 0) {
        $(".drawer").removeClass("is-visible");
        setTimeout(function () {
            $(".drawer").removeClass("is-active");
        }, 10000000);
    }
});

$('.product-form__submit').on('click', function () {
    setTimeout(function () {
        if ($(".main-product-form").hasClass("hasError")) {
            console.log('error');
        } else {
            $("#drawer-name").addClass("is-active");
            setTimeout(function () {
                    drawerUpdate();
                    $("#drawer-name").addClass("is-visible");
                    $('#shopify-section-header').css('padding-top', '0');
                    $('[data-slide-down-current]').slideUp(300);
                    $('[data-slide-down-current]').removeClass('active');
                
            }, 100);
        }
    }, 2000);
});

$(document).ready(function () {
    setTimeout(function () {
        var all = $(".hidden-div").map(function () {
            return this.innerHTML;
        }).get();
        var array = [];
        for (let i = 0; i < all.length; i++) {
            array.push(all[i].split(" -- "));
        }
        var filteredArray = [];
        var filteredArrayKeys = [];
        for (let j = 0; j < array.length; j++) {
            filteredArray.push({ handle: array[j][0], tags: array[j][1].split(",") })
        }

        for (let t = 0; t < filteredArray.length; t++) {
            for (let u = 0; u < filteredArray[t].tags.length; u++) {
                if (filteredArray[t].tags[u].includes("Photographer")) {
                    filteredArrayKeys.push({ handle: filteredArray[t].handle, photographer: filteredArray[t].tags[u] })
                }
            }
        }
        var final = [];
        for (let t = 0; t < filteredArrayKeys.length; t++) {
            final.push({ handle: filteredArrayKeys[t].handle, photographer: filteredArrayKeys[t].photographer.split("Photographer Name:")[1] });
        }

        for (let i = 0; i < final.length; i++) {
            $("#" + final[i].handle).text(final[i].photographer);
        }
    }, 2000);
});
$(document).on("click", ".drawer-trigger-class", function (){
  drawerUpdate();
});
$(document).on("click", ".add-to-cart-btn-swym", function (){
  let id = $(this).data("variant-id");
    var data = {
      "id": id,
      "quantity": 1,
    }
    jQuery.ajax({
      type: 'POST',
      url: '/cart/add.js',
      data: data,
      dataType: 'json',
      success: function () {
        $("#drawer-name").addClass("is-active");
        setTimeout(function () {
          drawerUpdate();
          $("#drawer-name").addClass("is-visible");
        }, 500);
      }
    });
});
function addItemToCartAjax(product_id, variant_id, qty, line_prop) {
  var data = {
    "id": variant_id,
    "quantity": qty,
    'properties': {
      '_Photographer Name': line_prop,
      'Framed': 'Unframed'
    }
  }

  jQuery.ajax({
    type: 'POST',
    url: '/cart/add.js',
    data: data,
    dataType: 'json',
    success: function () {
      $("#drawer-name").addClass("is-active");
      setTimeout(function () {
        $("#drawer-name").addClass("is-visible");
      }, 500);
    }
  });
}
document.addEventListener("boost-loaded", function(event) {
   console.log('boost-loaded');
  $(document).on("click", ".add-to-cart-btn-boost", function (e) {
    e.preventDefault();
    e.stopPropagation();
    var product_id = $(this).attr('product-data');
    var product_photographer = $(this).data('photographer');
    var product_handle = $(this).attr('product-handle');
    var url = "/products/" + product_handle + ".json";
    $.ajax({
      url: "https://" + window.location.hostname + url,
      type: 'GET',
      success: function (res) {
        addItemToCartAjax(res.product.id, res.product.variants[0].id, 1, product_photographer);
        setTimeout(function (){
          drawerUpdate();
        },500)
      },
    });
    });
});
$(document).on("click", ".add-to-cart-btn", function () {
  var product_id = $(this).attr('product-data');
  var product_photographer = $(this).data('photographer');
  var product_handle = $(this).attr('product-handle');
  var url = "/products/" + product_handle + ".json";
  $.ajax({
    url: "https://" + window.location.hostname + url,
    type: 'GET',
    success: function (res) {
      addItemToCartAjax(res.product.id, res.product.variants[0].id, 1, product_photographer);
      setTimeout(function (){
        drawerUpdate();
      },500)
    },
  });
  //  Sending data to Klaviyo
  let parentWrapper = $(this).parents('.card-wrapper');
  let klaviyoProductName = $(parentWrapper).find('.card-information__title').html();
  let klaviyoProductID = product_id;
  let klaviyoProductCategories = $(this).attr('data-categories');
  let klaviyoProductImageURL = $(parentWrapper).find('img').attr('src');
  let klaviyoProductURL = "https://"+ window.location.hostname + $(parentWrapper).children('.full-unstyled-link').attr('href');
  let klaviyoProductBrand = $(parentWrapper).find('.card-information__text').html();
  let klaviyoProductPrice = '$'+$(this).attr('data-price');
  let klaviyoProductCompareAtPrice = '$'+$(this).attr('data-price-max');


  var item = {
    Name: klaviyoProductName,
    ProductID: klaviyoProductID,
    Categories: klaviyoProductCategories,
    ImageURL: klaviyoProductImageURL,
    URL: klaviyoProductURL,
    Brand: klaviyoProductBrand,
    Price: klaviyoProductPrice,
    CompareAtPrice: klaviyoProductCompareAtPrice
  };

  _learnq.push(['track', 'Added to Cart', item]);
  console.log("tAdded to Cart'");
  console.log('_learnq456', _learnq);
});
$(document).on("click", ".images-quote__product--buttons--cart", function (){
  let variant = $(this).data("product-variant");
  let data = {
    "id": variant,
    "quantity": 1
  }
  jQuery.ajax({
    type: 'POST',
    url: '/cart/add.js',
    data: data,
    dataType: 'json',
    success: function () {
      $("#drawer-name").addClass("is-active");
      setTimeout(function () {
        $("#drawer-name").addClass("is-visible");
      }, 500);
      setTimeout(function (){
        drawerUpdate();
      },500)
    }
  });
});
$(document).on("click", ".wishlist-products__add", function (){
  let id = $(this).data("variant-id");
  var data = {
    "id": id,
    "quantity": 1,
  }
  jQuery.ajax({
    type: 'POST',
    url: '/cart/add.js',
    data: data,
    dataType: 'json',
    success: function () {
      $("#drawer-name").addClass("is-active");
      setTimeout(function () {
        drawerUpdate();
        $("#drawer-name").addClass("is-visible");
      }, 500);
    }
  });
});
